import { render, staticRenderFns } from "./OutOfOfficeFunctionbox.vue?vue&type=template&id=23c24c68"
import script from "./OutOfOfficeFunctionbox.vue?vue&type=script&lang=js"
export * from "./OutOfOfficeFunctionbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports